import { styled } from "styled-components";
import { useEffect, useState, useRef } from "react";
import {
  Chart as ChartJS,
  RadialLinearScale,
  ArcElement,
  Tooltip,
  Legend,
} from "chart.js";

import { PolarArea } from "react-chartjs-2";
// import adventurer from "../../../../assets/images/adventurer.png";
// import advisor from "../../../../assets/images/advisor.png";
// import analyst from "../../../../assets/images/analyst.png";
// import evaluator from "../../../../assets/images/evaluator.png";
// import facilitator from "../../../../assets/images/facilitator.png";
// import guardian from "../../../../assets/images/guardian.png";
// import innovator from "../../../../assets/images/innovator.png";
// import mediator from "../../../../assets/images/mediator.png";
// import planner from "../../../../assets/images/planner.png";
// import scholar from "../../../../assets/images/scholar.png";
// import strategist from "../../../../assets/images/strategist.png";
// import visionary from "../../../../assets/images/visionary.png";
import adventurer from "../../../../assets/icons/icon_adventurer_white.png";
import advisor from "../../../../assets/icons/icon_advisor_white.png";
import analyst from "../../../../assets/icons/icon_analyst_white.png";
import evaluator from "../../../../assets/icons/icon_evaluator_white.png";
import facilitator from "../../../../assets/icons/icon_facilitator_white.png";
import guardian from "../../../../assets/icons/icon_guardian_white.png";
import innovator from "../../../../assets/icons/icon_innovator_white.png";
import mediator from "../../../../assets/icons/icon_mediator_white.png";
import planner from "../../../../assets/icons/icon_planner_white.png";
import scholar from "../../../../assets/icons/icon_scholar_white.png";
import strategist from "../../../../assets/icons/icon_strategist_white.png";
import visionary from "../../../../assets/icons/icon_visionary_white.png";

ChartJS.register(RadialLinearScale, ArcElement, Tooltip, Legend);

const Main = styled.div`
  display: flex;
  align-items: center;
  width: 50%;
`;

export default function AssetDoughnutChart({
  chartData,
  chartCountData,
  count,
  titleText,
  group,
}) {
  const chartRef = useRef(null);

  const data = {
    labels: [
      "Category 1",
      "Category 2",
      "Category 3",
      "Category 4",
      "Category 5",
    ],
    datasets: [
      {
        label: "Dataset Label",
        data: chartData,
        countData: chartCountData,
        backgroundColor: [
          "#2F3958BF",
          "#2F3958BF",
          "#2F3958BF",
          "#5C647DBF",
          "#5C647DBF",
          "#5C647DBF",
          "#8991A1BF",
          "#8991A1BF",
          "#8991A1BF",
          "#030E33BF",
          "#030E33BF",
          "#030E33BF",
        ],
        borderColor: [
          "#ffffff",
          "#ffffff",
          "#ffffff",
          "#ffffff",
          "#ffffff",
          "#ffffff",
          "#ffffff",
          "#ffffff",
          "#ffffff",
          "#ffffff",
          "#ffffff",
          "#ffffff",
        ],
        borderWidth: 1,
      },
    ],
  };

  const options = {
    maintainAspectRatio: false,
    layout: {
      padding: {
        top: 60,
        right: 60,
        bottom: 60,
        left: 60,
      },
    },
    scales: {
      r: {
        beginAtZero: true,
        ticks: {
          display: false, // 숫자만 숨깁니다
        },
        grid: {
          display: true, // 격자선은 보이게 합니다
        },
        pointLabels: {
          display: false,
        },
      },
    },
    plugins: {
      legend: {
        display: false,
        position: "right",
      },
    },
    interaction: {
      mode: null,
      intersect: false,
    },
  };

  useEffect(() => {
    const plugin = {
      id: "centerImages",
      beforeDraw: (chart) => {
        if (chart.config._config.type != "polarArea") return;
        const ctx = chart.ctx;
        const chartArea = chart.chartArea;
        const dataset = chart.data.datasets[0].data;
        const countData = chart.data.datasets[0].countData;

        const images = [
          visionary,
          innovator,
          adventurer,
          analyst,
          strategist,
          evaluator,
          planner,
          scholar,
          guardian,
          facilitator,
          advisor,
          mediator,
        ];

        const legendText = [
          "비전가",
          "발명가",
          "모험가",
          "분석가",
          "전략가",
          "비평가",
          "설계자",
          "학자",
          "수호자",
          "촉진자",
          "상담자",
          "중재자",
        ];

        // const imageWidth = 60; // 이미지 너비 설정
        // const imageHeight = 60; // 이미지 높이 설정
        const MAX_WIDTH = 24; // 원하는 최대 너비
        const MAX_HEIGHT = 24; // 원하는 최대 높이

        const total = dataset.length;
        const centerX = chartArea.left + (chartArea.right - chartArea.left) / 2;
        const centerY = chartArea.top + (chartArea.bottom - chartArea.top) / 2;
        const radius = (chartArea.right - chartArea.left) / 2;
        for (let i = 0; i < total; i++) {
          const angle = (i / total) * Math.PI * 2 - Math.PI / 2; // 각도 계산 (0도는 위쪽을 향하도록 조정)
          const x = centerX + Math.cos(angle) * radius * 0.95;
          const y = centerY + Math.sin(angle) * radius * 0.95;

          ctx.save();
          ctx.beginPath();
          ctx.moveTo(centerX, centerY);
          ctx.lineTo(x, y);
          ctx.strokeStyle = "#8991A1BF"; // 선의 색상 (반투명 파란색)
          ctx.lineWidth = 0.5; // 선의 두께
          ctx.stroke();
          ctx.restore();
        }
        dataset.forEach((value, index) => {
          const img = new Image();
          img.src = images[index];

          img.onload = () => {
            let { width: imageWidth, height: imageHeight } = img;
            const aspectRatio = imageWidth / imageHeight;

            if (imageWidth > MAX_WIDTH || imageHeight > MAX_HEIGHT) {
              if (aspectRatio > 1) {
                // 너비가 높이보다 큰 경우
                imageWidth = MAX_WIDTH;
                imageHeight = MAX_WIDTH / aspectRatio;
              } else {
                // 높이가 너비보다 크거나 같은 경우
                imageHeight = MAX_HEIGHT;
                imageWidth = MAX_HEIGHT * aspectRatio;
              }
            }

            let angle =
              (index / dataset.length) * Math.PI * 2 - Math.PI / 2 + 0.2618;
            let angle2 =
              (index / dataset.length) * Math.PI * 2 - Math.PI / 2 + 1.8;
            const radius = (chartArea.right - chartArea.left) / 2;
            const heightFactor = value / Math.max(...dataset);
            let adjustedRadius = radius * heightFactor * 0.006;
            adjustedRadius = 2.4;
            const x =
              chartArea.left +
              radius +
              Math.cos(angle) * (radius / 2) * adjustedRadius;
            const y =
              chartArea.top +
              radius +
              Math.sin(angle) * (radius / 2) * adjustedRadius;

            ctx.save();
            ctx.beginPath();
            ctx.arc(x, y, 32, 0, 2 * Math.PI); // 반지름 20으로 설정 (원하는 크기로 조정 가능)
            if (index > 8) ctx.fillStyle = "#030E33BF";
            else if (index > 5) ctx.fillStyle = "#8991A1BF";
            else if (index > 2) ctx.fillStyle = "#5C647DBF";
            else ctx.fillStyle = "#2F3958BF";
            ctx.fill();
            ctx.restore();

            ctx.save(); // 상태 저장
            ctx.translate(x, y); // 이미지 중심으로 이동
            ctx.rotate(angle2); // 부채꼴 중심 각도에 맞춰 회전
            ctx.drawImage(
              img,
              -imageWidth / 2,
              -imageHeight / 2 - 15,
              imageWidth,
              imageHeight
            );

            ctx.font = `normal 10px Roboto Light`;
            ctx.fillStyle = "#ffffff";
            ctx.textAlign = "center";
            ctx.textBaseline = "middle";
            ctx.fillText(legendText[index], 0, imageHeight / 2 - 5);

            ctx.font = `normal 9px Roboto Light`;
            ctx.fillText(
              value + "% | " + countData[index] + "명",
              0,
              imageHeight / 2 + 7
            );
            ctx.restore();
          };
        });
      },
    };

    ChartJS.register(plugin);
    return () => {
      ChartJS.unregister(plugin);
    };
  }, [chartRef, chartData, chartCountData]);

  return (
    <div
      name="cat"
      style={{
        display: "inline-block",
        width: "450px",
        height: "450px",
        margin: "0px 25px",
        fontSize: "20px",
        fontWeight: "bold",
      }}
    >
      <p style={{ width: "100%", textAlign: "center" }}>
        {group}
        <br></br>그룹의 분석형 유형 상세 분포 ({count}명)
      </p>
      <PolarArea ref={chartRef} data={data} options={options} />
      <p
        style={{
          width: "100%",
          textAlign: "center",
          fontSize: "30px",
          marginTop: "30px",
          fontWeight: "bold",
        }}
      >
        {titleText}
      </p>
    </div>
  );
}
